// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"54":"modules","191":"moduleB","537":"moduleE","592":"moduleC","602":"moduleD","774":"loginB","900":"moduleA"}[chunkId] + "-legacy." + {"54":"f8b401a6","191":"92c30df2","537":"bc03d732","592":"66ede60b","602":"b7e7d46d","774":"50d1e9aa","900":"735e87ae"}[chunkId] + ".js";
};